<div>
  <div class="card">
    <div class="card-body">
      <div class="step-header d-flex align-items-center">
        <step-indicator
          [numberOfSteps]="3"
          [currentStep]="currentStep.value"
        ></step-indicator>
        <h1 class="selected-number">{{ currentStep.value + 1 }}</h1>
        <div class="form-title">
          <h4>{{ steps[currentStep.value].title }}</h4>
          <p class="text-muted">{{ steps[currentStep.value].description }}</p>
        </div>
      </div>
      <ng-container
        *ngComponentOutlet="steps[currentStep.value].component"
      ></ng-container>
    </div>
  </div>
  <div class="d-flex action-buttons">
    <div class="w-50 d-flex flex-column align-items-end">
      <button
        [disabled]="currentStep.value === 0"
        (click)="prevStep()"
        class="form-btn"
      >
        <i class="fa-solid fa-arrow-left"></i> Voltar
      </button>
    </div>
    <div class="w-50 d-flex flex-column align-items-start">
      <button
        (click)="nextStep()"
        class="form-btn activated"
      >
        Próximo <i class="fa-solid fa-arrow-right"></i>
      </button>
    </div>
  </div>
</div>
